module.exports = __webpack_public_path__ + "static/img/company_history_renwu2004.c5e01322.jpg";